import { Component } from '../../../libs/gin-tonic/helpers/compiler';

declare let gsap: any;
declare let Observer: any;

@Component({ className: 'js-magic-scroll-toggle-visibility' })
export class MagicScrollToggleVisibilityComponent {
	constructor(private element: HTMLElement) {
		gsap.registerPlugin(Observer);
		this.setTopStyle();

		Observer.create({
			target: window,
			type: 'scroll',
			tolerance: 50,
			onUp: () => this.element.classList.remove('is-hidden'),
			onDown: () => {
				if (window.scrollY > 100) {
					const isChildActive = this.element.querySelector('.js-hamburger.is-active');
					if (isChildActive == null) {
						this.element.classList.add('is-hidden')
					}
					this.element.classList.remove('is-top')
				}
			},
			onChange: () => this.setTopStyle()
		});
	}

	private setTopStyle() {
		this.element.classList.toggle('is-top', window.scrollY < 100)
	}
}
